'use strict';

import angular from 'angular';

// import modalDirective from 'brg/rest/buttons/modal';
import modalDirective from 'incidents/components/buttons/rest-modal';
import resolveUsers from 'utils/resolve/users';

import updateTemplate from './update.html';
import deleteTemplate from './delete.html';

const MODULE_NAME = 'daupler.entities.jcw.buppAppointments';

var app = angular.module(MODULE_NAME, [
]);


app.directive('updateBuppAppointment', modalDirective({
	template: updateTemplate,
	resolve: {users: resolveUsers},
}));

app.directive('deleteBuppAppointment', modalDirective({
	template: deleteTemplate,
}));

export default MODULE_NAME;
